module.exports = __webpack_public_path__ + "fdb8c0f88a65f0e6a185e60a13fa734b.pdf";